import { Star } from "@phosphor-icons/react";

export const Stars = ({ value = 0, size = 14 }) => (
  <span className="inline-flex items-center gap-0.5 text-[#C0A062]" data-testid="stars">
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} size={size} weight={n <= Math.round(value) ? "fill" : "regular"} />
    ))}
  </span>
);
